import * as tracker  from "../../settings/userTracker.json";

LN.UserTracker = new (function (Hotjar) {    
    var UsersToTrack = tracker.usuarios || [];
    this.verifyUserToTrackHotjar = function (userId) {
        for (var i = 0; i < UsersToTrack.length; i++) {
            if (UsersToTrack[i].id == userId) {
                console.log('user-tracking');
                Hotjar.startRecording(['UserId', userId]);
                return;                
            }
        }
    }
})(LN.Hotjar);


// WEBPACK FOOTER //
// ./Statics/scripts/common/user-tracker.js